import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@material-ui/core';
import React from 'react';
import { CircularProgress, TextField } from '@mui/material';
import SyncFusionChipper from './components/SyncFusionChipper';
import { chipperLoaderColumnData } from './Data/ColumnData';
const widthArr = {
  journeyDetails: '1800px',
  transfers: 'auto',
  weighbridge: '1600px',
};

const NotesSection = ({ value, disabled, onEdit }) => {
  return (
    <Box>
      <Typography variant="h6" style={{ marginBottom: 6 }}>
        Internal WH Notes
      </Typography>

      <TextField
        fullWidth
        multiline
        minRows={3}
        variant="outlined"
        value={value || ''}
        placeholder="No internal notes added"
        InputProps={{
          readOnly: true,
        }}
        disabled={disabled}
        onClick={onEdit}
        onFocus={onEdit}
      />
    </Box>
  );
};

const ChipperInfoDialog = ({
  open,
  chipperInfoData,
  handleCloseModal,
  chipperMainData,
  handleChipperEdit,
  handleChipperDocs,
}) => {
  console.log(chipperMainData, 'ddata');
  const headerUIArray = {
    weighbridge: chipperMainData?.formId ? (
      <Button size="small" variant="contained" color="primary" onClick={() => handleChipperEdit('weighbridge', null)}>
        Add
      </Button>
    ) : null,
  };

  return (
    <Dialog maxWidth="xl" open={open} onClose={handleCloseModal} disableAutoFocus disableEnforceFocus>
      <DialogTitle>
        <Typography style={{ fontSize: '1.5rem' }} component="div">
          Chipper Data - ID : {chipperMainData.formId ?? ''}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Box
          noValidate
          component="div"
          className="DocketInfoDialog"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            m: 'auto',
            width: '100%',
            height: '70vh',
            gap: '1rem',
            borderRadius: '0.5rem',
          }}>
          {Object.keys(chipperLoaderColumnData).map((section, index) => {
            console.log(chipperInfoData);
            return (
              <React.Fragment>
                {chipperInfoData ? (
                  <SyncFusionChipper
                    sectionName={section}
                    data={[chipperInfoData]}
                    handleChipperEdit={handleChipperEdit}
                    minWidth={widthArr[section]}
                    handleChipperDocs={handleChipperDocs}
                    headerUI={headerUIArray[section]}
                    chipperMainData={chipperMainData}
                  />
                ) : (
                  <Box
                    sx={{
                      width: '100%',
                      height: '200px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}>
                    <CircularProgress />
                  </Box>
                )}
                {/* {section === 'loadingDetails' && (
                    <NotesSection
                      value={chipperMainData?.internalNoteforWH}
                      onEdit={() => handleChipperEdit('loadingDetails', loadingRow)}
                    />
                  )} */}
              </React.Fragment>
            );
          })}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="primary" onClick={handleCloseModal}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ChipperInfoDialog;
